import axios from "axios";

export const getApiErrorMessage = (
  error: unknown,
  fallback: string
): string => {
  if (!axios.isAxiosError(error) || error.response?.status !== 400) {
    return fallback;
  }

  const data = error.response.data;

  return typeof data === "string" && data.trim() ? data : fallback;
};
